var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCardInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.25H15",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.75H15",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19531 11.75C8.23085 11.75 9.07031 10.9105 9.07031 9.875C9.07031 8.83947 8.23085 8 7.19531 8C6.15978 8 5.32031 8.83947 5.32031 9.875C5.32031 10.9105 6.15978 11.75 7.19531 11.75Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77417 13.625C4.91288 13.0883 5.22596 12.613 5.6642 12.2736C6.10245 11.9342 6.64102 11.75 7.19531 11.75C7.7496 11.75 8.28819 11.9341 8.72646 12.2735C9.16473 12.6128 9.47783 13.0882 9.61659 13.6248",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.25H3.125C2.77982 4.25 2.5 4.52982 2.5 4.875V16.125C2.5 16.4702 2.77982 16.75 3.125 16.75H16.875C17.2202 16.75 17.5 16.4702 17.5 16.125V4.875C17.5 4.52982 17.2202 4.25 16.875 4.25Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCardInfo);
export default __webpack_public_path__ + "static/media/user_card-info.10d2bc5c6f7489a6cec76458c4b89b13.svg";
export { ForwardRef as ReactComponent };